
// 在线终端---在线状态
const onlineDevice = (resolve) => {
  import('components/operation/operation.onlineDev').then((module) => {
    resolve(module)
  })
}
// 冲突终端---冲突终端
const conflictDevice = (resolve) => {
  import('components/operation/operation.conflictDev').then((module) => {
    resolve(module)
  })
}
// 未注册终端---在线状态
const unregisteredDevice = (resolve) => {
  import('components/operation/operation.unregisteredDevice').then((module) => {
    resolve(module)
  })
}
// 在线客户---在线状态
const onlineClient = (resolve) => {
  import('components/operation/operation.onlineClient').then((module) => {
    resolve(module)
  })
}
// 所有终端
const allDevice = (resolve) => {
  import('components/operation/operation.allDevice').then((module) => {
    resolve(module)
  })
}
// 库存终端
const inventoryDevice = (resolve) => {
  import('components/operation/operation.inventoryDevice').then((module) => {
    resolve(module)
  })
}
// 车辆年检
const deviceInspection = (resolve) => {
  import('components/operation/operation.deviceInspection').then((module) => {
    resolve(module)
  })
}
// 启用续费的设备
const devicePay = (resolve) => {
  import('components/operation/operation.devicePay').then((module) => {
    resolve(module)
  })
}
// 7天后欠费终端
const seven = (resolve) => {
  import('components/operation/operation.seven').then((module) => {
    resolve(module)
  })
}
// 30天后欠费终端
const thirty = (resolve) => {
  import('components/operation/operation.thirty').then((module) => {
    resolve(module)
  })
}
// 已欠费终端
const overdueDevice = (resolve) => {
  import('components/operation/operation.overdueDevice').then((module) => {
    resolve(module)
  })
}
// 终端管理---非admin账号
const deviceManage = (resolve) => {
  import('components/operation/operation.deviceManage').then((module) => {
    resolve(module)
  })
}
// 车队管理
const fleetManage = (resolve) => {
  import('components/operation/operation.fleetManage').then((module) => {
    resolve(module)
  })
}
// 公司信息
const company = (resolve) => {
  import('components/operation/operation.company').then((module) => {
    resolve(module)
  })
}
// 公司信息
const companyNew = (resolve) => {
  import('components/operation/operation.companyNew').then((module) => {
    resolve(module)
  })
}
// 司机管理
const driverManage = (resolve) => {
  import('components/operation/operation.driverManage').then((module) => {
    resolve(module)
  })
}
// 司机签到
const driverSignIn = (resolve) => {
  import('components/operation/operation.driverSignIn').then((module) => {
    resolve(module)
  })
}
// 司机管理 2
const driverManage2 = (resolve) => {
  import('components/operation/operation.driverManage2').then((module) => {
    resolve(module)
  })
}
// 关键字配置
const keywordConfig = (resolve) => {
  import('components/operation/operation.keywordConfig').then((module) => {
    resolve(module)
  })
}
// 角色管理
const roleManage = (resolve) => {
  import('components/operation/operation.roleManage').then((module) => {
    resolve(module)
  })
}
// 用户管理
const userManage = (resolve) => {
  import('components/operation/operation.userManage').then((module) => {
    resolve(module)
  })
}
// 运营路线管理
const lines = (resolve) => {
  import('components/operation/operation.lines').then((module) => {
    resolve(module)
  })
}
// 路线
const devLines = (resolve) => {
  import('components/operation/operation.devLines').then((module) => {
    resolve(module)
  })
}
// 学生管理
const studentManage = (resolve) => {
  import('components/operation/operation.studentManage').then((module) => {
    resolve(module)
  })
}

// 司机排班
const driverSchedule = (resolve) => {
  import('components/operation/operation.driverSchedule').then((module) => {
    resolve(module)
  })
}
// sim卡管理
const simCardManage = (resolve) => {
  import('components/operation/operation.simCardManage').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户操作汇总
const reportsUserOperationSummary = (resolve) => {
  import('components/operation/operation.UserOperationSummary').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户操作日志
const reportsUserOperationLog = (resolve) => {
  import('components/operation/operation.UserOperationLog').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户媒体汇总
const reportsUserMediaSummary = (resolve) => {
  import('components/operation/operation.UserMediaSummary').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-用户媒体明细
const reportsUserMediaDetail = (resolve) => {
  import('components/operation/operation.UserMediaDetail').then((module) => {
    resolve(module)
  })
}
// 用户行为分析-设备变更报表
const reportsUserDevUpdate = (resolve) => {
  import('components/operation/operation.UserDevUpdate').then((module) => {
    resolve(module)
  })
}
// 系统用户日志
const systemUserLog = (resolve) => {
  import('components/server/server.systemUserLog').then((module) => {
    resolve(module)
  })
}
// 服务器日志
const serverLog = (resolve) => {
  import('components/server/server.serverLog').then((module) => {
    resolve(module)
  })
}
// 公告管理
const noticeManage = (resolve) => {
  import('components/operation/operation.noticeManage').then((module) => {
    resolve(module)
  })
}

const operationRouter = {
  operationPath: [
    {
      path: '/operation/onlineDevice', // 在线终端---在线状态
      component: onlineDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/unregisteredDevice', // 未注册终端---在线状态
      component: unregisteredDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/conflictDevice', // 冲突终端---冲突终端
      component: conflictDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/onlineClient', // 在线客户---在线状态
      component: onlineClient,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/allDevice', // 所有终端
      component: allDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/inventoryDevice', // 库存终端
      component: inventoryDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/seven', // 7天后欠费终端
      component: seven,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/thirty', // 30天后欠费终端
      component: thirty,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/overdueDevice', // 已欠费终端
      component: overdueDevice,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/deviceInspection', // 车辆年检
      component: deviceInspection,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/devicePay', // 启用续费的设备
      component: devicePay,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/deviceManage', // 终端管理---非admin账号
      component: deviceManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/fleetManage', // 车队管理
      component: fleetManage,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/operation/company', // 公司信息
      component: company,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/companyNew', // 公司信息
      component: companyNew,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/driverManage', // 司机管理
      component: driverManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/driverManages', // 司机管理 2
      component: driverManage2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/driverSignIn', // 司机签到
      component: driverSignIn,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/roleManage', // 角色管理
      component: roleManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/userManage', // 用户管理
      component: userManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/lines', // 运营路线管理
      component: lines,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/devLines', // 运营路线管理
      component: devLines,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/studentManage', // 学生管理
      component: studentManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/simCardManage', // sim卡管理
      component: simCardManage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/driverSchedule', // 司机排班
      component: driverSchedule,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/UserOperationSummary', // 用户操作汇总(用户行为分析)
      component: reportsUserOperationSummary,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/UserOperationLog', // 用户操作日志(用户行为分析)
      component: reportsUserOperationLog,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/UserMediaSummary', // 用户媒体汇总(用户行为分析)
      component: reportsUserMediaSummary,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/UserMediaDetail', // 用户媒体明细(用户行为分析)
      component: reportsUserMediaDetail,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/UserDevUpdate', // 设备变更报表(用户行为分析)
      component: reportsUserDevUpdate,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/keywordConfig', // 关键字配置
      component: keywordConfig,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/systemUserLog', // 系统用户日志
      component: systemUserLog,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/serverLog', // 服务器日志
      component: serverLog,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/operation/noticeManage', // 公告管理
      component: noticeManage,
      meta: {
        keepAlive: true
      }
    }
  ]
}

export default operationRouter



// WEBPACK FOOTER //
// ./src/router/operation.js